import { parseBlockAttributes } from '../../../dom/parseBlockAttributes.js';
/**
 * Returns the block name and attributes
 *
 * @param node DomNode
 *
 * @returns
 */
export function useBlock(node) {
    // TODO: mark as deprecated
    const { attributes, name, className } = parseBlockAttributes(node);
    return {
        attributes: attributes,
        name,
        className,
    };
}
